import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import SetLimitEntries from '../../components/SetLimitEntries';
import filterIcon from '../../Res/Icon/filter-white.png';
import './monitor.css';
import CustomModal from '../../components/CustomModal';
import MonitorFilter from '../../components/MonitorFilter';
import { getMonitoring } from '../../actions/Monitoring';
import StatusView from '../../components/StatusView';
import utils from '../../lib/utils';
import { ENG_LOCALE } from '../../lib/constants';
import Spinner from '../../components/Spinner/Spinner';

const DashboardMonitor = () => {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.AppState.boxDetails.dashboardMonitoring) || [];

  const [loading, setLoading] = useState(false);
  const [modalstatus, setModalStatus] = useState(false);
  const [filterObject, setFilterObject] = useState({});
  const [filterPage, setFilterPage] = useState(1);

  const getDashboardData = async pagination => {
    setLoading(true);
    await dispatch(getMonitoring(token, pagination));
    setLoading(false);
  };

  useEffect(() => {
    const pagination = { page: 1, limit: 10 };
    getDashboardData(pagination);
  }, []);

  const handleSetLimit = limit => getDashboardData({ page: 1, limit });

  const handleChangePagination = page => {
    const { limit } = data;
    setFilterPage(page);
    const pagination = { page, limit };
    getDashboardData(pagination);
  };

  const filterObjectData = filter => {
    setFilterObject(filter);
  };

  const onApplyFilter = async () => {
    const { limit } = data;
    const pagination = { filterPage, limit };
    const filters = JSON.stringify(utils.removeEmptyKeyValues(filterObject));
    setLoading(true);
    await dispatch(getMonitoring(token, pagination, filters));
    setModalStatus(false);
    setLoading(false);
  };

  return (
    <>
      <div className="view-Container">
        {loading ? <Spinner /> : null}
        <div className="filter-monitor">
          <Button onClick={() => setModalStatus(true)} color="primary" className="filter-item">
            <h1 className="filter-text">Filter</h1>
            <img src={filterIcon} className="filter-icon" alt="filter" />
          </Button>
        </div>
        <div className="table-header-fixed">
          <table>
            <thead>
              <tr>
                <th className="cursor-pointer">Device</th>
                <th className="cursor-pointer">Alert</th>
                <th className="cursor-pointer" style={{ width: '300px' }}>
                  Company
                </th>
                <th className="cursor-pointer">Location</th>
                <th className="cursor-pointer">Description</th>
                <th className="cursor-pointer">Status</th>
                <th className="cursor-pointer">Date</th>
                <th className="cursor-pointer">Time</th>
              </tr>
            </thead>
            <tbody>
              {data?.docs?.map(element => {
                return (
                  <tr>
                    <td>{element?.serialNumber || '-'}</td>
                    <td>{element?.alert || '-'}</td>
                    <td>{element?.companyName || '-'}</td>
                    <td>{element?.location || '-'}</td>
                    <td>{element?.description || '-'}</td>
                    <td>
                      <StatusView status={element?.status} />
                    </td>
                    <td>{utils.getDateTimeFormat(element?.date, 'regular')}</td>
                    <td>{element?.date.split('T')[1].split('.')[0]}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {data && Object.keys(data).length ? (
          <Row className="justify-content-md-center">
            <SetLimitEntries value={10} onChange={handleSetLimit} />

            <Pagination
              locale={ENG_LOCALE}
              className="pagination-container"
              onChange={handleChangePagination}
              current={data.page}
              total={data.totalDocs}
              pageSize={data.limit}
              showLessItems
              showTitle={false}
              showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
            />
          </Row>
        ) : (
          <Row className="justify-content-md-center">
            <Col md="12" className="text-center">
              <h3>No Data Found</h3>
            </Col>
          </Row>
        )}
      </div>
      <CustomModal
        isOpen={modalstatus}
        onConfirm={onApplyFilter}
        onCancel={() => setModalStatus(false)}
        header="Filter"
        confirmBtnText="Apply Filter"
      >
        <MonitorFilter filterObject={filterObjectData} />
      </CustomModal>
    </>
  );
};

export default DashboardMonitor;
